var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.baseClass},[_c('span',{class:`${_vm.baseClass}__text ${_vm.baseClass}__text--name`},[_vm._v("\n    "+_vm._s(_vm.data.overall.keyword)+"\n  ")]),_c('div',{ref:"chart",class:`${_vm.baseClass}__chart`})])
}
var staticRenderFns = []

export { render, staticRenderFns }